import { ResponsiveDialog } from 'common-frontend'
import { SUPPORT_EMAIL } from 'consts'
import { Button, HelpEmail } from 'components'

export default class FailedDialog extends React.Component {

  constructor(props) {
    super(props)

    this.state = { show: true }
  }

  render() {
    return (
      <ResponsiveDialog
        title="Couldn't automatically install Plug in SEO Plus in your shop"
        maxWidth="600px"
        modal={true}
        open={this.state.show}
        onRequestClose={() => this.setState({ show: false })}
      >
        <div style={{ whiteSpace: 'pre-line' }} className="large-spacing2">
          <ol className="list large-spacing2--bottom">
            <li className="list__item">
              <a href='https://help.shopify.com/manual/your-account/staff-accounts/create-staff-accounts'>Add {SUPPORT_EMAIL} as a user</a> to your Shopify admin
            </li>
            <li className="list__item">
              Then drop us an email at <HelpEmail /> and we&apos;ll do the install for you (free of course)
            </li>
          </ol>
        </div>
        <Button
          label="Done"
          buttonType="secondary"
          onTouchTap={() => this.setState({ show: false })}
        />
      </ResponsiveDialog>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/plus/FailedDialog.js